import LegalLayout from "@/components/LegalLayout";

const CookiePolicyPage = () => (
  <LegalLayout eyebrow="Legal" title="Cookie Policy" updated="May 2026">
    <p>
      This page explains how Allen Travels RD uses cookies and similar technologies on this website.
    </p>

    <h2>1. What are cookies?</h2>
    <p>
      Cookies are small text files stored on your device when you visit a website. They help the site remember information about your visit.
    </p>

    <h2>2. How we use cookies</h2>
    <ul>
      <li><strong>Essential cookies</strong> — required for booking flow, payments, and authentication.</li>
      <li><strong>Analytics cookies</strong> — help us understand how visitors use the site so we can improve it.</li>
      <li><strong>Functional cookies</strong> — remember preferences such as language or last selected destination.</li>
    </ul>

    <h2>3. Third-party cookies</h2>
    <p>
      We may use trusted third-party services (Google Maps, payment providers, analytics) that set their own cookies. Their use is governed by their respective privacy policies.
    </p>

    <h2>4. Managing cookies</h2>
    <p>
      You can control or delete cookies via your browser settings. Disabling essential cookies may prevent parts of the site from working correctly.
    </p>

    <h2>5. Contact</h2>
    <p>
      Questions? Reach us at <a href="mailto:hello@allentravelsrd.com">hello@allentravelsrd.com</a>.
    </p>
  </LegalLayout>
);

export default CookiePolicyPage;
